import apis from "../apis"
import Native from '../../utils/Native'
import utils from '../../utils/util'
import msgParse from '../msgParse'
import { log } from "util";

/**
 * 初始化流程
 * 1. 获取用户信息(pc：api.fundTrade ; app: Native.getLoginMsg)
 * 2. 通过getPresetQuestions 获取用户当前聊天状态  -1： 机器人  1：排队   2： 客服
 * 3. 通知 sdk 初始化
 *
 *
 * 转人工
 * 1. 查看是否有客服在线 applyLineup
 * 2. 判断客服状态，若未接通2s后再次调用  getStaff
 */
export default function BusEvents(store) {

    // 初始化
    Bus.$on("initEvent", (sceneId) => { //zxw 222

      logger(`=== SceneId: ${sceneId} ===`);

      store.commit("m_scene_id", sceneId)

        // 设置标题
        Native.setRobotTitle();
        // 通过设备或浏览器cookie获取用户信息
        if (Native.isFund()) {
            Native.getLoginMsg(function(res) {
                store.commit('m_device_info', res);
                //zxw 去掉预置问题 改成获取用户信息 进入通道
				Bus.$emit("getStaffInfo", (res) => {
					store.commit("m_fund_info", res);
				})
                // apis.getPresetQuestions(store.getters.presetQuestionParam)
                //     .then(res => {
                //         if (res.Code == "000") {
                //             var customerInfo = res.Data.CustomerInfo
                //             store.commit("m_preset_question", res.Data.PresetQuestions);
                //             store.commit('m_fund_info', res.Data.CustomerInfo);
                //         }
                //     })
                //     .catch(e => {
                //         logger(e)
                //     })
            })
        } else {
             apis.fundTrade(function(res) {
                console.log(111,res)
                store.commit('m_device_info', { devicetype: "pc", uid: decodeURIComponent(res.CustomerNo), customername: res.CustomerName });
                Bus.$emit("getStaffInfo", (res) => {
					store.commit("m_fund_info", res);
				})
            })

            // apis.fundTrade(function(res) {
            //     console.log(111,res)
            //     store.commit('m_device_info', { devicetype: "pc", uid: decodeURIComponent(res.CustomerNo), customername: res.CustomerName });
            //     apis.getPresetQuestions(store.getters.presetQuestionParam)
            //       .then(res => {
            //           if (res.Code == "000") {
            //             var customerInfo = res.Data.CustomerInfo
            //             store.commit("m_preset_question", res.Data.PresetQuestions);
            //             store.commit('m_fund_info', res.Data.CustomerInfo);
            //           }
            //       });
            // })
        }

    })
    Bus.$on("getStaffInfo", (cb = () => { }) => {
		apis
			.getStaffInfo(store.getters.presetQuestionParam)
			.then(res => {
				cb && cb(res)
			})
			.catch(e => {
				logger("加入通道失败", e);
			});
	})

    var welcomeMsgHasShow = false;
    Bus.$on("welcomeMsg", () => {
        if (!welcomeMsgHasShow) {
            msgParse.welcomeMsg(store.getters.presetQuestion);
            welcomeMsgHasShow = true;
        }
    })

    Bus.$once("setEvaluate", () => {
        Native.setEvaluate(true)
    })

    // 相似问题刷新事件
    Bus.$on("refreshQuestions", (id) => {
        apis.getPresetQuestions(store.getters.presetQuestionParam)
            .then(res => {
                if (res.Code == "000") {
                    store.commit("m_robot_say", msgParse.getQuestions(res.Data.PresetQuestions, id))
                }
            })
    })

    var staffInputingTimer = null;
    Bus.$on("staffInputing", () => {
        staffInputingTimer && clearTimeout(staffInputingTimer);
        Native.setTitle("客服" + store.getters.staffId, "正在输入")
        staffInputingTimer = setTimeout(() => {
            Native.setTitle("人工客服", "客服" + store.getters.staffId)
        }, 1000)
    })

    //  订阅 websocket token 刷新事件
    Bus.$on("refreshToken", (token) => {
        store.commit('m_accessToken', token)
    })

    // 订阅转客服事件
    Bus.$on("applyLineup", (cb, msgid) => {
        if (store.getters.calling != 0) {
            return;
        }
        store.commit('m_calling', 1);
        apis.applyLineupWithDeviceId(store.getters.applyLineupParams).then(res => {
                switch (res.RetCode) {
                    case 1:
                        switch (res.Data.ApplyType) {
                            case 1: //排队成功
                            case 2: //客户不存在 这个时候会有channel
                            case 3: //已经在排队
                                store.commit('m_calling', 2);
                                store.commit("m_customer_state", 1)
                                Bus.$emit("getStaff", cb);
                                break;
                            case 4: //已经有客服接待了
                                Bus.$emit("clearstafftimer")
                                break;
                            case 5:
                                store.commit('m_update_txt_tip', msgParse.getTxtTip(res.Message, -1))
                                break;
                            default:
                        }
                        break;
                    case 0:
                        Bus.$emit("getStaff")
                        break;
                    case 20:
                        //当客服不在线的时候 显示感叹号
						store.commit("m_msg_status", {
							msgid: msgid,
							msgStatus: 2
						});
                        Bus.$emit("staffoffline")
                        break;
                    default:
                }
               // cb && cb(res)
            })
            .catch(err => {
                Bus.$emit("staffoff")
                store.commit('m_calling', 0);
                store.commit("m_customer_state", 0)
                cb && cb(err)
            })
    })

    Bus.$on("cancelLineUp", (type) => {
        Bus.$emit("clearstafftimer")
        apis.cancelLineup(store.getters.customerId)
            .then(res => {
                if (res.RetCode) {
                    //取消失败，进入人工
                    if (res.Data === false) {
                        Bus.$emit("getStaff")
                    } else {
                        //取消成功，回到机器人
                        store.commit('m_calling', 0)
                        store.commit('m_customer_state', 0)
                        store.commit('m_remove_msg', 'lineup')
                        store.commit(
							"m_update_txt_tip",
							type ? msgParse.showClientTplMsg(type) : msgParse.getTxtTip('您已取消转接人工客服', -1)
						);
                    }
                }
            })
            .catch(err => {
                logger("error:", err)
            })
    })


    Bus.$on("removeMsg", id => {
      store.commit('m_remove_msg', id)
    })

    Bus.$on("timeout", (msg) => {
        store.commit('m_update_txt_tip', msgParse.getTxtTip(msg, -1))
    })

    Bus.$on("updateTxtTip", (msg, btnType) => {
      store.commit('m_update_txt_tip', msgParse.getTxtTip(msg, btnType || -1))
    })

    Bus.$on("blurryQuestions", arr => {
        store.commit('m_blurry_questions', arr)
    })

    // getStaff 用于判断客服状态
    var getstafftimer = null;
    Bus.$on('clearstafftimer', () => {
        store.commit('m_calling', 0);
        store.commit("m_customer_state", 0)
        clearTimeout(getstafftimer);
        getstafftimer = null;
    })

    // 获取客服状态
    Bus.$on("getStaff", cb => {
        // 延迟2s 判断客服状态

        getstafftimer && clearTimeout(getstafftimer);
        getstafftimer = setTimeout(() => {
            Bus.$emit("getStaff", cb)
        }, 2000);

        apis.getStaff(store.getters.customerId)
            .then(res => {
                getstafftimer && Bus.$emit("staffStatus", res);

                if (res.RetCode == 1 && res.Data.CustomerState == 2) {
                    cb && cb()
                    Bus.$emit("clearstafftimer")
                    store.commit('m_calling', 3)
                    store.commit("m_customer_state", 2)
                    store.commit("m_channel_id", res.Data.ChannelId)
                    store.commit('m_update_txt_tip', msgParse.getTxtTip(res.Data.StaffId, 1))
                    Bus.$emit("sendCustomerHeart")
                }

            })
            .catch(err => {
                // msgParse.showClientTplMsg("netError");
                Bus.$emit("cancelLineUp", "netError")
                Bus.$emit("clearstafftimer")
            })
    })

    Bus.$on("staffStatus", data => {
            switch (data.RetCode) {
                case 0:
                    Bus.$emit("clearstafftimer");
                    store.commit('m_update_txt_tip', msgParse.getTxtTip("网络异常，请稍后再试", -1))
                    break;
                case 1:
                    //成功了
                    if (data.Data.CustomerState == 2) {
                        Native.setTitle("人工客服", "客服" + data.Data.StaffId)
                        store.commit("m_staffId", data.Data.StaffId)
                            // startCustomer(data.Data.StaffId);
                    }
                    break;
                case 21: //表示用户正在排队,表示当前没有客服接待
                    store.commit('m_update_txt_tip', msgParse.getTxtTip(data.Message))
                    break;
                case 20: //没有客服在线，直接跳留言板
                case 25: //不是客服工作时间
                    Bus.$emit("staffoffline")
                    break;
            }
        })
        // 客服离线
    Bus.$on("staffoffline", cb => {
      store.commit('m_calling', 0);
      store.commit("m_customer_state", 0)
      Bus.$emit("clearstafftimer");
      msgParse.showClientTplMsg("staffOffLine", "msgFromPeople");
      Bus.$emit("removeMsg", 'lineup');
      Bus.$emit("exitStaff", window.configs["staffOffLine"])
      cb && cb();
    })

    // 链接成功后开始心跳
    var sendCustomerHeartTimer = null;
    Bus.$on("sendCustomerHeart", cb => {
        sendCustomerHeartTimer = setTimeout(() => {
            Bus.$emit("sendCustomerHeart", cb)
            //Bus.$emit("comparehistory", cb); //zxw  有心跳后开始比较内容
        }, 2000);

        apis.sendCustomerHeart(store.getters.customerId)
            .then(res => {
                if (res.RetCode !== 1) {
                    throw Error("fail")
                }
            })
            .catch(err => {
                Bus.$emit("closeHeart", err)
            })
    })

    Bus.$on('closeHeart', () => {
        store.commit('m_calling', 0)
        store.commit("m_customer_state", 0)
        welcomeMsgHasShow = false;
        store.commit('m_update_txt_tip', msgParse.getTxtTip(configs["endchat"], -1))
        
        Bus.$emit("getStaffInfo", (res) => {
			store.commit("m_channel_id", res.ChannelId);
			welcomeMsgHasShow = false;
			Bus.$emit("welcomeMsg");
        })
        
        // apis.getPresetQuestions(store.getters.presetQuestionParam)
        //     .then(res => {
        //         if (res.Code == "000") {
        //             store.commit("m_preset_question", res.Data.PresetQuestions);
        //             store.commit('m_channel_id', res.Data.CustomerInfo.ChannelId);
        //             Bus.$emit("welcomeMsg")
        //         }
        //     })
        //     .catch(e => {
        //         logger(e)
        //     })
        clearTimeout(sendCustomerHeartTimer);
        sendCustomerHeartTimer = null;
        Native.setRobotTitle();
    })


     //比较聊天记录是不是有遗漏
  Bus.$on("comparehistory", cb => {
    var _customerState = store.getters.customerState;
    var _channelId = store.getters.channelId;
    if (_customerState == 2) {  //如果在频道中 并且有历史记录，才会合并记录
      getMessagefromredis(_channelId, cb)

    }
  })

  // //从redis里获取聊天记录
  function getMessagefromredis(_channelId, cb) {
    apis
      .GetMessageFromRedis({
        channelID: _channelId,
      })
      .then(res => {
        let listim = []
        for (let obj of res.Data) {
          listim.unshift(obj)
        }
        listim.splice(5)
        let nowList = []
        let listobj = $("div[userType='3']")
        listobj = listobj.length <= 8 ? listobj : listobj.slice(listobj.length - 9)
        for (let e of listobj) {
          nowList.push($(e).attr("content").trim().replace(/[\r\n]/g, ""))
        }
        //找出没有显示的消息 
        let noshowList = []
        for (let obj of listim) {
          let pat = /{.*,FileName:.*}/
          let IMcontent = obj.Content
          if (pat.test(IMcontent)) { //图片 文件暂不处理
          } else {
            if (nowList.indexOf(IMcontent.trim().replace(/[\r\n]/g, "")) == -1) {
              noshowList.push(obj)
            }
          }
        }
        noshowList = noshowList.reverse()
        for (let i = 0; i < noshowList.length; i++) {
          let content = noshowList[i]
          let MsgContent = {
            "Content": content.Content,
            "Extension": "zxkf_001",
            "SenderID": content.AuthorId,
            "ID": content.ID,
            "SenderName": ""
          }
          var _data = msgParse.genMsg.getNormalMsg(MsgContent);
          $historyStorage.push(
            Object.assign({}, MsgContent, { Type: 2, SendDateTime: new Date(content.Timestamp).getTime() })
          );
          Bus.$emit("normalMsg", _data);
        }

      })
  }


    // 获取历史记录
    var historyPage = 0;
    var historyEmpty = false;
    var localList = $historyStorage.getAll();
    var historyList = [];
    Bus.$on('getClientHistoryMessages', cb => {
      if (historyEmpty) {return}

      if (historyPage === 0) {
        // 实名合并实名聊天记录
        if (store.getters.customerId.length !== 16) {
          apis.getClientHistoryMessagesByDeviceId({
            page: historyPage + 1,
            pageSize: 80,
            ...store.getters.getClientHistoryMessagesParams
          })
          .then(res => {
            if (res.RetCode == 1) {
              let _list = res.Data;
              for(let i = 0 ; i < _list.length; i++) {
                _list[i].SendDateTime = _list[i].SendTime && _list[i].SendTime.split("/Date(")[1].split(")/")[0];
              }
              historyList = historyList.concat(_list || [], localList);
              historyList = utils.quickSort(historyList, 'SendDateTime').splice(0,80);
              Bus.$emit("showPageHistory", cb)
            }
          })
        } else {
          historyList = historyList.concat(localList);
          historyList = utils.quickSort(historyList, 'SendDateTime').splice(0,80);
          Bus.$emit("showPageHistory", cb)
        }
      } else {
        Bus.$emit("showPageHistory", cb)
      }
    })

    Bus.$on("showPageHistory", cb => {
      let list = historyList.splice(0, 20);
      if (list.length < 20) {
        historyEmpty = true;
        store.commit('m_history_empty', true)
      }
      msgParse.dealHistoryMsg(list)
      // Bus.$emit("showHistoryMsg", list);
      historyPage++;
      cb && cb()
    })

    Bus.$on("showHistoryMsg", (msg) => {
        store.commit('m_msg_history', msg)
    })

    Bus.$on("autoMsg", (msg) => {
        store.commit('m_msg_list', msg)
    })

    Bus.$on("normalMsg", (msg) => {
        store.commit('m_msg_list', msg)
    })

    // 文本消息 type=scene时不显示 文本（针对“人工客服”）
    Bus.$on("sendText", (msg, type) => {
        var _msg = msgParse.dealSendMsg(msg);
        if (msg.Basequestion) _msg.Basequestion = msg.Basequestion;
        if (msg.Questiontype) _msg.Questiontype = msg.Questiontype;
		if (type == 'scene') {
			Bus.$emit("sendMsg", _msg, type);
		} else {
			store.commit("m_msg_list", _msg);
			Bus.$emit("sendMsg", _msg);
        }
    })

    // 发送消息
    Bus.$on("sendMsg", (_msg, type) => {
      var _customerState = store.getters.customerState
        if (_customerState === -1) {
          return;
        }
        store.commit('m_msg_status', { msgid: _msg.msgid, msgStatus: 1 })
        if (_msg.msgType == 1) {
            var cbChatWithStaff = function () {  //正常情况下发送消息
				if (type == 'scene') {
					return
				}
                var sendMsg = msgParse.parseToSendMsg(_msg.content);
                Bus.$emit("sendMsgToIM", sendMsg.msg, sendMsg.ct, () => {
                    store.commit('m_msg_status', { msgid: _msg.msgid, msgStatus: 2 })
                }, () => {
                    store.commit('m_msg_status', { msgid: _msg.msgid, msgStatus: 3 })
                    Bus.$emit("sendToIMFail", `pc消息发送失败:${_msg.content}`)
                })
				Bus.$emit("sendMessage", _msg.content);
            }

            var cbBeforeChatWithStaff = function () {   //进入人工之前发送消息
				Bus.$emit(
					"SendMessageToRobot",
					_msg,
					() => {
						store.commit("m_msg_status", {
							msgid: _msg.msgid,
							msgStatus: 2
						});
					},
					() => {
						store.commit("m_msg_status", {
							msgid: _msg.msgid,
							msgStatus: 3
						});
					}
				);
			}
			var cbReSendMessage = function () { //进入人工之后重新发送消息
				var sendMsg = msgParse.parseToSendMsg(_msg.content);
				setTimeout(function() {
                    Bus.$emit("sendMsgToIM",sendMsg.msg, 100, () => {}, () => {})
					Bus.$emit("ReSendMessage",_msg,
						() => { },
						() => { }
					);
				},1000)
			}



			if (store.getters.customerState == 0) {
                cbBeforeChatWithStaff()
				Bus.$emit("applyLineup", cbReSendMessage, _msg.msgid);
			} else if (store.getters.customerState == 1) {
                cbBeforeChatWithStaff()
                msgParse.showClientTplMsg("adverise");
				// Bus.$emit("applyLineup", cbReSendMessage, _msg.msgid);
			} else {
				cbChatWithStaff()
            }
        } else if (_msg.msgType == 2) { // 图片消息发送
            Bus.$emit("sdkUploadImg", _msg.fileName, _msg.content.split(";base64,")[1], (res) => {
                if (res.result == 1) {
                    var res = res.data;
                    // 遗留的奇葩格式，需要同客服端一同修改
                    var imgStr = `{Url:${res.Url},FileName:${res.FileName},ThumbUrl:${res.ThumbUrl},UrlEnd:UrlEnd}`;
                    var sendMsg = msgParse.parseToSendMsg(imgStr);
                    Bus.$emit("sendMsgToIM", sendMsg.msg, sendMsg.ct, () => {
                        store.commit('m_msg_status', { msgid: _msg.msgid, msgStatus: 2 })
                    }, () => {
                        store.commit('m_msg_status', { msgid: _msg.msgid, msgStatus: 3 })
                        Bus.$emit("sendToIMFail", `pc消息发送失败:${imgStr}`)
                    })
                }
                Bus.$emit('sendMessage', imgStr)
            }, () => {
                // Bus.$emit("sendToIMFail", "sdkUploadImg 异常")
                store.commit('m_msg_status', { msgid: _msg.msgid, msgStatus: 3 })
            })
        }
        Bus.$emit('setEvaluate')
    })

    /**
     * 发送图片消息
     */
    Bus.$on("sendImage", (msg) => {
        utils.fileObjToStr(msg, (imgStr) => {
            var _msg = msgParse.dealSendMsg({
                msg: imgStr,
                name: msg.name
            }, 1);

            utils.getImgWidthAndHeight(imgStr, (imgSize) => {
                _msg.imgWidth = imgSize.width || 0;
                _msg.imgHeight = imgSize.height || 0;

                store.commit("m_msg_list", _msg)

                Bus.$emit("sendMsg", _msg)
            })

        })
    })

    /**
     * 向机器人提问
     * @param {Object} msg 消息 {content: '', SmallTypeId: ''}   content 不可为空 SmallTypeId可为空
     * @param {Function} cb 成功回调
     * @param {Function} errCb 失败回调
     */
    Bus.$on("askRobot", (msg, cb, errCb) => { //机器人
        var data = {
            Question: msg.content, // 提问的问题
            SmallTypeId: msg.SmallTypeId || "",
            Basequestion: msg.Basequestion,
            Questiontype: msg.Questiontype
        }

        var params = Object.assign({}, data, store.getters.askRobotParams);

        $historyStorage.push({Type: 9, MessageContent: params.Question, SendDateTime: new Date().getTime()})

        apis.askRobot(params)
            .then(res => {
                if (res.Code === '000') {
                    var qid = res['Data']['QuestionId']
                    store.commit('m_channel_id', res['Data']['ChannelId'])
                    store.commit("m_msg_loading_list", msgParse.getRobotLoading(qid));
                    cb && cb(qid)

                    if (!!params.SmallTypeId) {
                        if (store.getters.customerState == 0) {
                            Bus.$emit("bigDataFeedback", {
                                qid: qid,
                                type: 2,
                                content: params.Question,
                                iid: params.SmallTypeId
                            })
                        }
                    }
                } else {
                    throw res.Message;
                }
            })
            .catch(err => {
                errCb && errCb()
            })
    })

    // 监听消息, 扔给msgParse 处理
    Bus.$on("messages", msg => {
        logger("messages", msg)
        msgParse.dealMsg(msg);
    })

    // 监听消息，扔到消息列表显示
    Bus.$on("toMsgList", msg => {
        store.commit('m_msg_list', msg)
    })

    // 机器人回答问题，并计数
    Bus.$on("robotSay", msg => {
        if (msg.id === "callPeople") {
            store.commit('m_update_callpeople', msg)
        } else {
            store.commit('m_robot_say', msg)
        }
    })

    //　调用后会直接转接人工
    Bus.$on("toCustomer", str => {
        Bus.$emit('applyLineup')
    })

    window.toCustomer = function () {
      Bus.$emit("toCustomer");
    };

    Bus.$on("endchatMsg", () => {
        Bus.$emit("closeHeart");
    })

    Bus.$on("endchat", () => {
        apis.endChat(store.getters.customerId);
        Native.setRobotTitle();
    })

    Bus.$on("downloadImg", (url, oldStr, msgid,onlyImg) => {
        logger("downloadImg", url, oldStr, msgid, onlyImg)
		var $img = document.createElement('img');
		logger("downloadImg", $img)
		$img.onload = () => {
			if (utils.onlyHasImg(msgid) || onlyImg) {
				store.commit('m_update_type_img', {
					msgid: msgid,
					content: `${url}`,
					fileName: `${url}`,
					imgHeight: $img.naturalHeight,
					imgWidth: $img.naturalWidth,
					msgType: 2
				});
			} else {
				store.commit('m_update_img', {
					link: `<img src='${url}' imgWidth='${$img.naturalWidth}' imgHeight='${$img.naturalHeight}'/>`,
					oldLink: oldStr,
					msgid: msgid
				})
			}
			$img = null;
		}
		$img.onerror = () => {
			logger("$img.onerror=====", url, oldStr, msgid)
			store.commit('m_update_type_img', {
				msgid: msgid,
				content: `./static/img/errorimg.png`,
				fileName: `errorimg.png`,
				msgType: 2,
				width: 100
			});
			$img = null;
		}
		$img.src = url;
    })

    Bus.$on("downloadFile", (url, msgid) => {
        apis.downLoadFile(url, store.getters.imConfig)
            .then(res => {
                store.commit('m_update_file', {
                    url: res,
                    loaded: true,
                    msgid: msgid
                })
            }).catch(err => {
                logger("downloadFile err", err)
            })
    })

    /**
     * 模糊查询
     */
    Bus.$on("getSimilarQuestion1", str => {
        if (str.trim() == "") {
          return;
        }
        var params = Object.assign({}, store.getters.getSimilarQuestionParam, {
          question: str || "",
          count: 5
    
        });
        apis
          .getSimilarQuestion1(params)
          .then(res => {
            console.log(res)
            if (res.Code === "000") {
              store.commit("m_similar_obj", {
                key: res.Data.segWords,
                list: res.Data.standardSentence
              });
            } else {
                store.commit('m_similar_obj', { key: [], list: [] })
            }
          })
          .catch(err => {
            store.commit('m_similar_obj', { key: [], list: [] })
          });
      });

    // Bus.$on("getSimilarQuestion", (str) => {
    //     if (str.trim() == '') {
    //         return;
    //     }
    //     var params = Object.assign({}, store.getters.getSimilarQuestionParam, { Question: str || '' })
    //     apis.getSimilarQuestion(params)
    //         .then(res => {
    //             if (res.Code === '000') {
    //                 store.commit('m_similar_obj', { key: str, list: res.Data })
    //             } else {
    //                 store.commit('m_similar_obj', { key: '', list: [] })
    //             }
    //         })
    //         .catch(err => {
    //             store.commit('m_similar_obj', { key: '', list: [] })
    //         })
    // })

    /**
	 * 进入人工之前发送消息
	 * @param {Object} msg 消息 {content: '', SmallTypeId: ''}   content 不可为空 SmallTypeId可为空
	 * @param {Function} cb 成功回调
	 * @param {Function} errCb 失败回调
	 */
	Bus.$on("SendMessageToRobot", (msg, cb, errCb) => {
		var data = {
			content: msg.content, // 提问的问题
		};
		var params = Object.assign({}, data, store.getters.sendMessageParams);
		console.log(123, params)
		$historyStorage.push({
			Type: 9,
			MessageContent: params.content,
			SendDateTime: new Date().getTime()
		});
		apis
			.beforeChat(params)
			.then(res => {
				if (res.RetCode == 1) {
					cb && cb()
				} else {
					throw res.Message;
				}
			})
			.catch(err => {
				errCb && errCb();
			});
	});

	/**
	 * 进入人工之后重新发送消息
	 * @param {Object} msg 消息 {content: '', SmallTypeId: ''}   content 不可为空 SmallTypeId可为空
	 * @param {Function} cb 成功回调
	 * @param {Function} errCb 失败回调
	 */
	Bus.$on("ReSendMessage", (msg, cb, errCb) => {
		var data = {
			content: msg.content, // 提问的问题
		};
		var params = Object.assign({}, data, store.getters.sendMessageParams);
		apis
			.enterChatReSendMessage(params)
			.then(res => {
				if (res.RetCode == 1) {
					cb && cb()
				} else {
					throw res.Message;
				}
			})
			.catch(err => {
				errCb && errCb();
			});
    });
    

    Bus.$on("sendMessage", (str) => { //转人工的
        var params = Object.assign({}, { content: str }, store.getters.sendMessageParams)
        apis.sendMessageWithDeviceId(params);
    })

    // 发送到IM失败调用
    Bus.$on("sendToIMFail", (str) => {
      var params = Object.assign({}, {content: str}, store.getters.sendMessageParams)
      apis.SendMessageWithDeviceIdAndMarket(params);
    })


    var actionsheetHasShow = false
    Bus.$on("triggerFeedActionsheet", (cb, closeConn) => {
        if (actionsheetHasShow) {
            return;
        }
        actionsheetHasShow = true;
        $vue.$actionSheet({
            clickEvent: (item) => {
                actionsheetHasShow = false;
                closeConn && Bus.$emit("endchat")
                if (item !== "cancel") {
                    Bus.$emit("ExitFeedback", ++item, cb)
                } else {
                    cb && cb()
                }
                Native.setEvaluate(false);
            }
        })
    })

    // var actionsheetHasShow = false
    Bus.$on("triggerFeedconfirm", (cb, closeConn) => {
        $vue.$confirm({})
    })


    Bus.$on("bigDataFeedback", params => {
        // 不直接调用大数据反馈
        return;
        var qaUserOptParams = Object.assign({}, store.getters.qaUserOptParams, params)
        apis.qaUserOpt(qaUserOptParams)
    })

    // 退出时调用的反馈接口
    Bus.$on("ExitFeedback", (result, cb) => {
        if (store.getters.customerState == 0) {
            Bus.$emit("bigDataFeedback", {
                qid: "",
                type: 1,
                content: result,
                iid: ""
            })
        }
        var params = Object.assign({}, { FeedbackResult: result }, store.getters.feedbackParams);
        apis.feedback(params)
            .then(res => {
                if (res.Code === '000') {
                    cb && cb()
                } else {
                    throw "err";
                }
            })
            .catch(err => {
                cb && cb()
            })
    })

    Bus.$on("robotRefreshTime", () => {

        if (store.getters.customerState === 2) {
            return;
        }
        apis.robotRefreshTime(store.getters.customerId)
            .then(res => {
                if (res.RetCode == 1 && res.Data) {

                } else {
                    throw '';
                }
            })
            .catch(err => {
                window.location.reload();
            })
    })

    // 机器人反馈
    Bus.$on("robotFeedback", (feedbackTypeObj, feedbackQAObj) => {
        store.commit("m_feedback_obj", "")
        var _str = `robotFeedBack${feedbackTypeObj.FeedbackResult}`;
        var _customerStr = `customerFeed${feedbackTypeObj.FeedbackResult}`;
        var _feedRes = feedbackTypeObj.FeedbackResult;
        if (feedbackTypeObj.FeedbackType == 1) {
            store.commit("m_msg_list", msgParse.dealSendMsg(configs[_customerStr]));
        }

        var params = Object.assign({}, feedbackTypeObj, feedbackQAObj, store.getters.robotFeedbackParams)

        Bus.$emit("bigDataFeedback", {
            qid: params.QuestionId,
            type: 1,
            content: params.FeedbackResult,
            iid: params.SmallTypeId
        })

        apis.feedback(params)
            .then(res => {
                if (res.Code === "000") {
                    if (feedbackTypeObj.FeedbackType == 1) {
                        var questions = store.getters.blurryQuestions;
                        if (_feedRes == 4) {
                            msgParse.callPeople(_str)
                        } else if (_feedRes == 1 || _feedRes == 3) {
                            msgParse.showClientTplMsg(res.Data.RspContent)
                        } else if (_feedRes == 2) {
                            if (questions.length > 0) {
                                store.commit("m_msg_list", msgParse.getQuestions(questions, '', res.Data.RspContent, '', false))
                            } else {
                                msgParse.showClientTplMsg(_str)
                            }
                        }
                    }
                }
            })
    })

    Bus.$on("openDebug", () => {
            apis.loadScript("//cdn.bootcss.com/eruda/1.4.2/eruda.min.js", () => {
                eruda.init();
            })
        })
        //g改变输入字体样式
        // debug 时使用  或在输入框输入  njtest-pppppp
        // Bus.$emit("openDebug")

    // 用于发送其他类型消息到客服端，zxkf_002: 客户输入的文字
    Bus.$on("sendInputMsgToCustomer", (msg, type, ct) => {
        var data = { "Extension": type, "Content": msg };
        data = JSON.stringify(data);
        Bus.$emit("sendMsgToIM", data, ct);
    })
}



// WEBPACK FOOTER //
// ./src/store/plugins/BusEvents.js